import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";

import Auth from "../containers/Auth";

const PrivateRoute = ({
  component: Component,
  isAuthenticated,
  permissions,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated ? (
          <Auth>
            <Component {...props} />
          </Auth>
        ) : (
          <Redirect
            to={{
              pathname: "/login"
            }}
          />
        )
      }
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
  location: PropTypes.object,
  isAuthenticated: PropTypes.bool.isRequired
};

// Retrieve data from store as props
function mapStateToProps(store) {
  return {
    isAuthenticated: store.auth.isAuthenticated,
    permissions: store.auth.permissions
  };
}

export default connect(mapStateToProps)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/system/routes/Private.jsx